import * as React from 'react'
import {H1} from '@frontrow/console/src/components/typography'
import {
  fetchRlStandardSets,
  type RlStandardSetT
} from '@frontrow/console/src/entities/models/rl-standard-set'
import {ContentAreas} from '@frontrow/console/src/entities/helpers/content-area'
import {SpinnerOverlay} from '@frontrow/console/src/components/spinner'

import {StandardSetsPage} from '@frontrow/console/src/components/pages/standard-sets-page/standard-sets-page'

type State = {
  mathStandardSets: RlStandardSetT[]
  elaStandardSets: RlStandardSetT[]
}

export function StandardSetsContainer(): React.ReactElement {
  const [state, setState] = React.useState<State | null>(null)
  React.useEffect(() => {
    Promise.all([
      fetchRlStandardSets(ContentAreas.math) as Promise<RlStandardSetT[]>,
      fetchRlStandardSets(ContentAreas.ela) as Promise<RlStandardSetT[]>
    ]).then(([mathStandardSets, elaStandardSets]) => setState({mathStandardSets, elaStandardSets}))
  }, [])

  if (state === null) {
    return <SpinnerOverlay />
  }

  return (
    <React.Fragment>
      <H1>Standard Sets</H1>
      <StandardSetsPage {...state} />
    </React.Fragment>
  )
}
